export async function scrollToErrorField(element: HTMLElement): Promise<boolean> {
    const scrollContainer = document.querySelector('.PageWrapper') as HTMLElement;
    if (!scrollContainer) {
        console.warn('Scroll container not found: .PageWrapper');
        return false;
    }

    // Step 1: If sticky view is not active, scroll to activate it first
    let scrolledSummary = document.querySelector('.DocumentDataReviewEntitySummary--scrolled');
    if (!scrolledSummary) {
        const header = document.querySelector('.DocumentDataReview__header');
        const summary = document.querySelector('.DocumentDataReviewEntitySummary');
        const scrollToActivateSticky =
            (header?.getBoundingClientRect().height || 0) +
            (summary?.getBoundingClientRect().height || 0);

        scrollContainer.scrollTo({ top: scrollToActivateSticky, behavior: 'auto' });
        await new Promise((resolve) => setTimeout(resolve, 200));

        // Re-check for sticky view after scroll
        scrolledSummary = document.querySelector('.DocumentDataReviewEntitySummary--scrolled');
        if (!scrolledSummary) {
            console.warn('Sticky view not activated after pre-scroll');
            return false;
        }
    }

    // Step 2: Now scroll to the actual field with correct offset
    const stickyHeight = scrolledSummary.getBoundingClientRect().height;
    const containerRect = scrollContainer.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    const relativeTop = elementRect.top - containerRect.top;
    const targetScrollTop = scrollContainer.scrollTop + relativeTop - stickyHeight - 16;

    scrollContainer.scrollTo({ top: targetScrollTop, behavior: 'smooth' });
    return true;
}

